import createDecorator from 'final-form-submit-listener';
export const flattenObject = (obj, prefix = '') => Object.entries(obj).reduce((aggr, [fieldName, errorMessage]) => {
    const name = prefix.length ? `${prefix}.${fieldName}` : fieldName;
    if (typeof errorMessage === 'object' && errorMessage !== null) {
        return {
            ...aggr,
            ...flattenObject(errorMessage, name),
        };
    }
    if (errorMessage && typeof errorMessage === 'string') {
        return { ...aggr, [name]: errorMessage };
    }
    return aggr;
}, {});
const getPosition = (element) => element.getBoundingClientRect().top + window.scrollY;
const defaultGetElement = (name) => {
    const element = (document.getElementsByName(name)[0] ?? null) || document.getElementById(name) || document.getElementById(`${name}-error`);
    return element?.parentElement ?? element;
};
const defaultScrollTo = (element) => {
    if (element) {
        window.scrollTo({
            top: getPosition(element),
        });
    }
};
const defaultConfig = {
    getElement: defaultGetElement,
    scrollTo: defaultScrollTo,
};
const createScrollToError = (config) => (inputErrors) => {
    const { getElement, scrollTo } = { ...defaultConfig, ...config };
    const errors = flattenObject(inputErrors);
    const element = Object.keys(errors)
        .map((fieldName) => getElement(fieldName))
        .filter((el) => !!el)
        .reduce((upperElement, el) => {
        if (!upperElement || getPosition(el) < getPosition(upperElement)) {
            return el;
        }
        return upperElement;
    }, null);
    if (element) {
        scrollTo(element);
    }
};
const createFinalFormDecorator = (config) => createDecorator({
    beforeSubmit: (formApi) => {
        const { invalid, errors } = formApi.getState();
        if (invalid && errors) {
            createScrollToError(config)(errors);
        }
    },
});
const createFinalFormDecoratorAfterSubmit = (config) => createDecorator({
    afterSubmitFailed: (formApi) => {
        const { invalid, submitErrors } = formApi.getState();
        if (invalid && submitErrors) {
            createScrollToError(config)(submitErrors);
        }
    },
});
export { defaultScrollTo, defaultGetElement, getPosition, createFinalFormDecorator, createFinalFormDecoratorAfterSubmit, createScrollToError, };
